import { useQuery } from '@hooks/reactQuery';

import { getNetworkElementsTypes } from '@api/networkElements';

import { nameTitleToOptionFormatted } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { NETWORK_ELEMENTS_TYPE_OPTIONS } from '@constants/queryKeys';

interface IUseQueryNetworkElementsTypesReturned {
	typeOptions: TSelectOption[];
	isLoadingTypeOptions: boolean;
}

const useQueryNetworkElementsTypes = (): IUseQueryNetworkElementsTypesReturned => {
	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [NETWORK_ELEMENTS_TYPE_OPTIONS],
		queryFn: getNetworkElementsTypes,
		select: nameTitleToOptionFormatted,
		...refetchOptions,
	});

	return {
		typeOptions: data || [],
		isLoadingTypeOptions: isInitialLoading,
	};
};

export default useQueryNetworkElementsTypes;
